import { render } from "./NeedsReviewGuard.vue?vue&type=template&id=35c89280"
import script from "./NeedsReviewGuard.vue?vue&type=script&lang=js"
export * from "./NeedsReviewGuard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__